<template>
    
    <div class="row">

        <div class="col-md-4">
            <!-- Form Input -->
            <div class="form-group">
                <label>Agregar {{ label }}</label>
                <input type="text" class="form-control" v-model="elemento" v-on:keyup.enter="AgregarElemento()" placeholder="Nombre Apellido" >
                <button class="btn btn-sm btn-primary mt-1" type="button" @click="AgregarElemento()">Agregar</button>
            </div>
        </div>
        <div class="col-md-8">
            <label>{{ label }}</label>
            <ul v-if="elementos.length > 0">
                <li v-for="(el, index) in elementos" :key="index">
                    {{ el }}
                    <button type="button" class="btn btn-sm text-danger" @click="EliminarElemento(index)">
                        <i class="fas fa-times"></i>
                    </button>
                </li>
            </ul>
            <p v-else>
                <em>No hay <span class="text-lowercase">{{ label }}</span> registrados</em>
            </p>
        </div>
        <input type="hidden" :name="name" v-model="res">

    </div>

</template>

<script>
    export default {
        data() {
            return {
                elemento: '',
                elementos: [],
                res: '',
            }
        },
        props: {
            name: {required: true},
            label: {required: true},
            prop_elementos: {requried: false, default: null},
            values: {requried: false, default: null},
        },
        mounted() {
            if(this.prop_elementos) {
                this.res = this.prop_elementos;

                this.elementos = JSON.parse(this.prop_elementos);
            }
            if(this.values) {
                this.elementos = JSON.parse(this.values);
                this.res = JSON.stringify(this.elementos);
            }
        },
        methods: {
            AgregarElemento() {
                if(this.elemento){
                    this.elementos.push(this.elemento);
                    this.elemento = "";

                    this.res = JSON.stringify(this.elementos);
                }
            },
            EliminarElemento(index) {
                this.elementos.splice(index, 1);
                this.res = JSON.stringify(this.elementos);
            }
        }
    }
</script>